<template>
  <div :class="notificationClasses" role="alert">
    <div v-if="notification.has_icon" class="alert-icon">
      <i :class="notification.icon" />
    </div>
    <!--
      we should use v-html instead of sanitise here, since we want freedom
      and have total control (in admin) of what actually ends up in the notif
    -->
    <!-- eslint-disable-next-line vue/no-v-html -->
    <div class="alert-text" v-html="notification.body" />
    <div class="alert-close">
      <button type="button" class="close"
              data-dismiss="alert"
              aria-label="Close" @click="notificationDismiss(notification.id)">
        <span><i class="la la-close" /></span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    notification: {
      type: Object,
      required: true,
    },
    setCookieOnDismiss: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  computed: {
    notificationClasses() {
      const vm = this;
      let notification_style_classes = '';
      const has_icon = '';
      let elevate = '';

      if (this.notification.style_classes !== 'default') {
        // There can be multiple classes, split them by space so we can loop to see if they need colours appending
        notification_style_classes = _.split(this.notification.style_classes, ' ');
        _.forEach(notification_style_classes, (notification_style_class, index) => {
          // If the class ends in a dash, the it's expecting a colour
          if (notification_style_class[notification_style_class.length - 1] === '-') {
            // Assign the colour to this class
            notification_style_classes[index] = notification_style_class + vm.notification.colour_classes;
          }
        });
        notification_style_classes.join(" ");
      }

      // if (this.notification.has_icon) {
      //   has_icon = ' kt-alert--icon';
      // }

      if (this.notification.elevate) {
        elevate = ' alert-elevate';
      }

      return `alert ${notification_style_classes}${has_icon}${elevate} fade show ${this.notification.colour_classes} w-100`;
    },
  },
  methods: {
    notificationDismiss(notification_id) {
      if (this.setCookieOnDismiss) {
        // Set cookie for a year so it never shows again.
        window.cookies.set(`dashboard_notification_dismissed_${notification_id}`, true, '1y');
      }
      EventBus.$emit('notification_dismissed', {
        notification_id: notification_id,
      });
    },
  },
};
</script>
